export const getUserToken = () => {
    const storedToken = localStorage.getItem("brakorn-token");

    if (storedToken) {
        return storedToken;
    }
}